import * as ambassadorWixPromotePublisherV1Item from './promote-publisher-v1-item-items.http.js';
import * as ambassadorWixPromotePublisherV1ItemTypes from './promote-publisher-v1-item-items.types.js';
import * as ambassadorWixPromotePublisherV1ItemUniversalTypes from './promote-publisher-v1-item-items.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function publishItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPromotePublisherV1ItemUniversalTypes.PublishItemRequest,
  ambassadorWixPromotePublisherV1ItemTypes.PublishItemRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.PublishItemResponse,
  ambassadorWixPromotePublisherV1ItemTypes.PublishItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.publishItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/publish',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishItemById(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPromotePublisherV1ItemUniversalTypes.PublishItemByIdRequest,
  ambassadorWixPromotePublisherV1ItemTypes.PublishItemByIdRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.PublishItemByIdResponse,
  ambassadorWixPromotePublisherV1ItemTypes.PublishItemByIdResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.publishItemById(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/publish-by-id',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createDraftItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPromotePublisherV1ItemUniversalTypes.CreateDraftItemRequest,
  ambassadorWixPromotePublisherV1ItemTypes.CreateDraftItemRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.CreateDraftItemResponse,
  ambassadorWixPromotePublisherV1ItemTypes.CreateDraftItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.createDraftItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishMultiStoryDraft(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPromotePublisherV1ItemUniversalTypes.PublishMultiStoryDraftRequest,
  ambassadorWixPromotePublisherV1ItemTypes.PublishMultiStoryDraftRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.PublishMultiStoryDraftResponse,
  ambassadorWixPromotePublisherV1ItemTypes.PublishMultiStoryDraftResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.publishMultiStoryDraft(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/publish-multi-story-draft',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getItem(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixPromotePublisherV1ItemUniversalTypes.GetItemRequest,
  ambassadorWixPromotePublisherV1ItemTypes.GetItemRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.GetItemResponse,
  ambassadorWixPromotePublisherV1ItemTypes.GetItemResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.getItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPromotePublisherV1ItemUniversalTypes.GetItemsRequest,
  ambassadorWixPromotePublisherV1ItemTypes.GetItemsRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.GetItemsResponse,
  ambassadorWixPromotePublisherV1ItemTypes.GetItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.getItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPromotePublisherV1ItemUniversalTypes.QueryItemsRequest,
  ambassadorWixPromotePublisherV1ItemTypes.QueryItemsRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.QueryItemsResponse,
  ambassadorWixPromotePublisherV1ItemTypes.QueryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.queryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelScheduledItem(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixPromotePublisherV1ItemUniversalTypes.CancelScheduledItemRequest,
  ambassadorWixPromotePublisherV1ItemTypes.CancelScheduledItemRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.CancelScheduledItemResponse,
  ambassadorWixPromotePublisherV1ItemTypes.CancelScheduledItemResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.cancelScheduledItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/items/{id}/cancel',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateItem(): __PublicMethodMetaInfo<
  'PATCH',
  { itemId: string },
  ambassadorWixPromotePublisherV1ItemUniversalTypes.UpdateItemRequest,
  ambassadorWixPromotePublisherV1ItemTypes.UpdateItemRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.UpdateItemResponse,
  ambassadorWixPromotePublisherV1ItemTypes.UpdateItemResponse
> {
  const payload = { item: { id: ':itemId' } } as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.updateItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/items/{item.id}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rescheduleItem(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPromotePublisherV1ItemUniversalTypes.RescheduleItemRequest,
  ambassadorWixPromotePublisherV1ItemTypes.RescheduleItemRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.RescheduleItemResponse,
  ambassadorWixPromotePublisherV1ItemTypes.RescheduleItemResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.rescheduleItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/{id}/reschedule',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteItem(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixPromotePublisherV1ItemUniversalTypes.DeleteItemRequest,
  ambassadorWixPromotePublisherV1ItemTypes.DeleteItemRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.DeleteItemResponse,
  ambassadorWixPromotePublisherV1ItemTypes.DeleteItemResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.deleteItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/items/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkPublishItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPromotePublisherV1ItemUniversalTypes.BulkPublishItemsRequest,
  ambassadorWixPromotePublisherV1ItemTypes.BulkPublishItemsRequest,
  ambassadorWixPromotePublisherV1ItemUniversalTypes.BulkPublishItemsResponse,
  ambassadorWixPromotePublisherV1ItemTypes.BulkPublishItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromotePublisherV1Item.bulkPublishItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/publish',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  ChannelName as ChannelNameOriginal,
  ChannelNameWithLiterals as ChannelNameWithLiteralsOriginal,
  PublishingTarget as PublishingTargetOriginal,
  ConsumerType as ConsumerTypeOriginal,
  ConsumerTypeWithLiterals as ConsumerTypeWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  ItemAutomation as ItemAutomationOriginal,
  ItemAutomationTriggerOneOf as ItemAutomationTriggerOneOfOriginal,
  ItemAutomationActionOneOf as ItemAutomationActionOneOfOriginal,
  CommentTrigger as CommentTriggerOriginal,
  SendPrivateReplyAction as SendPrivateReplyActionOriginal,
  Channel as ChannelOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeWithLiterals as ItemTypeWithLiteralsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  SchedulingInfo as SchedulingInfoOriginal,
  ConsumerInfo as ConsumerInfoOriginal,
  InstagramPost as InstagramPostOriginal,
  InstagramPostUrlOneOf as InstagramPostUrlOneOfOriginal,
  MediaWrapper as MediaWrapperOriginal,
  Media as MediaOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  InstagramInsights as InstagramInsightsOriginal,
  InstagramStory as InstagramStoryOriginal,
  InstagramStoryInsights as InstagramStoryInsightsOriginal,
  FacebookPost as FacebookPostOriginal,
  FacebookPostUrlOneOf as FacebookPostUrlOneOfOriginal,
  LinkMetadata as LinkMetadataOriginal,
  FacebookInsights as FacebookInsightsOriginal,
  FacebookImpressions as FacebookImpressionsOriginal,
  FacebookInteractions as FacebookInteractionsOriginal,
  FacebookReactions as FacebookReactionsOriginal,
  FacebokActivity as FacebokActivityOriginal,
  FacebookReel as FacebookReelOriginal,
  FacebookStory as FacebookStoryOriginal,
  YouTubeVideo as YouTubeVideoOriginal,
  YoutubeInsights as YoutubeInsightsOriginal,
  YouTubeShort as YouTubeShortOriginal,
  LinkedinPost as LinkedinPostOriginal,
  LinkedinPostUrlOneOf as LinkedinPostUrlOneOfOriginal,
  LinkedinPostInsights as LinkedinPostInsightsOriginal,
  TwitterPost as TwitterPostOriginal,
  TwitterPostUrlOneOf as TwitterPostUrlOneOfOriginal,
  TwitterInsights as TwitterInsightsOriginal,
  PinterestPost as PinterestPostOriginal,
  PinterestInsights as PinterestInsightsOriginal,
  GbpPost as GbpPostOriginal,
  GbpPostCallToAction as GbpPostCallToActionOriginal,
  GbpPostCallToActionType as GbpPostCallToActionTypeOriginal,
  GbpPostCallToActionTypeWithLiterals as GbpPostCallToActionTypeWithLiteralsOriginal,
  GbpInsights as GbpInsightsOriginal,
  TikTokVideo as TikTokVideoOriginal,
  TikTokPrivacyLevel as TikTokPrivacyLevelOriginal,
  TikTokPrivacyLevelWithLiterals as TikTokPrivacyLevelWithLiteralsOriginal,
  TikTokInsights as TikTokInsightsOriginal,
  TikTokPhoto as TikTokPhotoOriginal,
  SiteAnalytics as SiteAnalyticsOriginal,
  ConversionFunnel as ConversionFunnelOriginal,
  InsightsSummary as InsightsSummaryOriginal,
  DraftInfo as DraftInfoOriginal,
  PublicationErrorDetails as PublicationErrorDetailsOriginal,
  AssetReference as AssetReferenceOriginal,
  ItemAutomationsWrapper as ItemAutomationsWrapperOriginal,
  PublishItemRequest as PublishItemRequestOriginal,
  ItemExtras as ItemExtrasOriginal,
  PublishItemResponse as PublishItemResponseOriginal,
  ItemPublishStarted as ItemPublishStartedOriginal,
  ItemPublished as ItemPublishedOriginal,
  ItemPublishFailed as ItemPublishFailedOriginal,
  ItemPublishScheduled as ItemPublishScheduledOriginal,
  PublishItemByIdRequest as PublishItemByIdRequestOriginal,
  PublishItemByIdResponse as PublishItemByIdResponseOriginal,
  CreateDraftItemRequest as CreateDraftItemRequestOriginal,
  CreateDraftItemResponse as CreateDraftItemResponseOriginal,
  GetOrCreateWixelBindingByFileRequest as GetOrCreateWixelBindingByFileRequestOriginal,
  GetOrCreateWixelBindingByFileResponse as GetOrCreateWixelBindingByFileResponseOriginal,
  PublishDraftRequest as PublishDraftRequestOriginal,
  PublishDraftResponse as PublishDraftResponseOriginal,
  PublishMultiStoryDraftRequest as PublishMultiStoryDraftRequestOriginal,
  PublishMultiStoryDraftResponse as PublishMultiStoryDraftResponseOriginal,
  BulkItemsResult as BulkItemsResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  IsEligibleForSchedulingRequest as IsEligibleForSchedulingRequestOriginal,
  IsEligibleForSchedulingResponse as IsEligibleForSchedulingResponseOriginal,
  SchedulingRestrictedReason as SchedulingRestrictedReasonOriginal,
  SchedulingRestrictedReasonWithLiterals as SchedulingRestrictedReasonWithLiteralsOriginal,
  GetItemRequest as GetItemRequestOriginal,
  GetItemResponse as GetItemResponseOriginal,
  GetItemsRequest as GetItemsRequestOriginal,
  GetItemsResponse as GetItemsResponseOriginal,
  QueryItemsRequest as QueryItemsRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  Paging as PagingOriginal,
  QueryItemsResponse as QueryItemsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  CancelScheduledItemRequest as CancelScheduledItemRequestOriginal,
  CancelScheduledItemResponse as CancelScheduledItemResponseOriginal,
  UpdateItemRequest as UpdateItemRequestOriginal,
  UpdateItemResponse as UpdateItemResponseOriginal,
  RescheduleItemRequest as RescheduleItemRequestOriginal,
  RescheduleItemResponse as RescheduleItemResponseOriginal,
  DeleteItemRequest as DeleteItemRequestOriginal,
  DeleteItemResponse as DeleteItemResponseOriginal,
  BulkPublishItemsRequest as BulkPublishItemsRequestOriginal,
  BulkPublishItemsPolicy as BulkPublishItemsPolicyOriginal,
  BulkPublishItemsPolicyWithLiterals as BulkPublishItemsPolicyWithLiteralsOriginal,
  BulkPublishItemsResponse as BulkPublishItemsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  PublishItemApplicationErrors as PublishItemApplicationErrorsOriginal,
  PublishItemByIdApplicationErrors as PublishItemByIdApplicationErrorsOriginal,
  PublishMultiStoryDraftApplicationErrors as PublishMultiStoryDraftApplicationErrorsOriginal,
  CancelScheduledItemApplicationErrors as CancelScheduledItemApplicationErrorsOriginal,
  UpdateItemApplicationErrors as UpdateItemApplicationErrorsOriginal,
  RescheduleItemApplicationErrors as RescheduleItemApplicationErrorsOriginal,
  DeleteItemApplicationErrors as DeleteItemApplicationErrorsOriginal,
  BulkPublishItemsApplicationErrors as BulkPublishItemsApplicationErrorsOriginal,
} from './promote-publisher-v1-item-items.types.js';
